import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_World_Img1 from '../images/balloonsodyssey/balloonsodyssey-maps-02.png';


export default function BalloonsOdyssey_World_Section02() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: farm to orange forest map"
        description="Map containing 20 puzzles in Balloons Odyssey."
        images={[BalloonsOdyssey_World_Img1]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}